(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mega-menu"] && !Shopify.designMode) return;
  try {
    (() => {
  const initializeMegaSwitchers = () => {
    document.querySelectorAll('[data-fp-menu-switcher]').forEach((menu) => {
      if (menu.dataset.fpInitialized === 'true') return;

      menu.dataset.fpInitialized = 'true';

      const triggers = Array.from(menu.querySelectorAll('[data-fp-menu-trigger]'));
      const panels = Array.from(menu.querySelectorAll('[data-fp-menu-panel]'));

      const activate = (trigger) => {
        const panelId = trigger.dataset.fpPanelId;
        if (!panelId) return;

        triggers.forEach((item) => {
          item.dataset.active = item === trigger ? 'true' : 'false';
        });

        panels.forEach((panel) => {
          panel.hidden = panel.id !== panelId;
        });
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('mouseenter', () => activate(trigger));
        trigger.addEventListener('focus', () => activate(trigger));
      });
    });
  };

  initializeMegaSwitchers();
  document.addEventListener('shopify:section:load', initializeMegaSwitchers);
})();
  } catch(e) { console.error(e); }
})();

})();
